import { formatUnits } from "@ethersproject/units";
import { BigNumber } from "@ethersproject/bignumber";
import { PLP_DECIMALS } from "pages/Event/hooks/constants";

export const formatUnitsPlp = (value: BigNumber) => {
  return formatUnits(value, PLP_DECIMALS);
};
